export default "__VITE_PUBLIC_ASSET__67090acb__"